import React from 'react'

export function cloudCheck() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        className="fill"
        d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04Z"
        fill="#104573"
      />
      <path
        d="M10 17L6.5 13.5L7.91 12.09L10 14.17L14.59 9.59L16 11L10 17Z"
        fill="#FFFFFF"
      />
    </svg>
  )
}
